export const CRM_ACTIVITY_EVENT_TYPES = {
  ENTITY_CREATED: 'entity_created',
  ENTITY_UPDATED: 'entity_updated',
  ENTITY_DELETED: 'entity_deleted',
  STATUS_CHANGED: 'status_changed',
  COMMENT_ADDED: 'comment_added',
  COMMENT_UPDATED: 'comment_updated',
  COMMENT_DELETED: 'comment_deleted',
  LEAD_ATTACHED_TO_PARTNER: 'lead_attached_to_partner',
  LEAD_DETACHED_FROM_PARTNER: 'lead_detached_from_partner',
  TASK_CREATED: 'task_created',
  TASK_UPDATED: 'task_updated',
  TASK_COMPLETED: 'task_completed',
  TASK_CANCELLED: 'task_cancelled',
  TASK_DELETED: 'task_deleted',
  FILE_ATTACHED: 'file_attached',
  FILE_REMOVED: 'file_removed',
  PARTNER_MERGED: 'partner_merged',
  LEAD_WON_FEEDBACK: 'lead_won_feedback',
} as const;

export type CrmActivityEventType =
  (typeof CRM_ACTIVITY_EVENT_TYPES)[keyof typeof CRM_ACTIVITY_EVENT_TYPES];

export const CRM_ACTIVITY_SOURCES = {
  USER: 'user',
  AGENT: 'agent',
  CRON: 'cron',
  SYSTEM: 'system',
} as const;

export type CrmActivitySource = (typeof CRM_ACTIVITY_SOURCES)[keyof typeof CRM_ACTIVITY_SOURCES];

export const CRM_ACTIVITY_ENTITY_TYPES = {
  PARTNER: 'crm::PartnerRepository',
  LEAD: 'crm::LeadRepository',
  DEAL: 'crm::DealRepository',
} as const;

/** Тип сущности DM-диалога (личная переписка двух сотрудников). */
export const ACTIVITY_DM_ENTITY_TYPE = 'activity::DmConversationRepository';

/** Тип сущности задач (треды задач-проектов ведутся на саму задачу). */
export const ACTIVITY_TASK_THREAD_ENTITY_TYPE = 'tasks::TaskRepository';

/** Slug типа задачи «Проект» (см. сид 01-project-task-type). */
export const ACTIVITY_PROJECT_TASK_TYPE_SLUG = 'PROJECT';

/** Genesis-событие DM-треда (скрыто в чате, см. event-registry). */
export const ACTIVITY_DM_CONVERSATION_CREATED_EVENT = 'dm_conversation_created';
